import React, { useCallback } from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { useSafeAnalytics } from '@/utils/analytics'
import { Tab } from '../Details/Details'
import { useDetailsContext } from '../DetailsProvider'

interface Props {
  isEmbed: boolean
}

export const SectionTabs: React.FC<Props> = ({ isEmbed }) => {
  const { selectedTab, setTab, tabs } = useDetailsContext()
  const { track } = useSafeAnalytics()

  const handleClick = useCallback(
    (tab: Tab) => {
      if (!setTab) return

      const newTab = document.getElementById(`${tab.id}-anchor`)
      newTab?.scrollIntoView({ behavior: 'smooth', block: 'start' })

      setTab(tab.sysId)
      track('Section Tab Clicked', {
        name: tab.title,
      })
    },
    [setTab, track],
  )

  if (!tabs || tabs.length < 2) return null

  return (
    <div
      className={classNames('sticky z-50 bg-core-gray-100 pt-1 shadow-light-1', {
        'top-0': isEmbed,
        'top-16': !isEmbed,
      })}
    >
      <div className="mx-auto flex overflow-x-auto whitespace-nowrap px-4 scrollbar-none md:px-10 lg:max-w-[816px] lg:px-0 2lg:max-w-screen-xl 2lg:px-8">
        {tabs.map((tab) => (
          <Button
            key={tab.sysId}
            variant="plain"
            className={classNames('px-4 py-2 border-b-[3px] border-transparent', {
              'text-core-gray-700': selectedTab !== tab.sysId,
              'border-core-oxide font-bold text-core-oxide': selectedTab === tab.sysId,
            })}
            onClick={() => handleClick(tab)}
          >
            {tab.linkText || tab.title}
          </Button>
        ))}
      </div>
    </div>
  )
}
